import CreateTextField from './CreateTextField'
export default CreateTextField




// WEBPACK FOOTER //
// ./src/components/CreateTextField/index.js